export const pl = {
  HOME: {
    value: '',
  },
  LOGIN: {
    value: 'login',
  },
  PLAN_MEETING: {
    value: 'zaplanuj-wizytę',
  },
  PLAN_MEETING_TYPE: {
    value: 'typ',
  },
  PLAN_MEETING_DOCTOR: {
    value: 'specjalista',
  },
  PLAN_MEETING_SUMMARY: {
    value: 'podsumowanie',
  },
  PLAN_MEETING_SUMMARY_SMS: {
    value: 'podsumowanie-sms',
  },
  ABOUT_SCHEDULED_MEETING: {
    value: 'o-wizycie',
  },
  EDIT_SCHEDULED_MEETING: {
    value: 'edytuj-wizyte',
  },
  PAYMENT_SUMMARY: {
    value: 'podsumowanie-platnosci',
  },

  NEW_VISIT: {
    value: 'nowa-wizyta',
    path: 'nowa-wizyta',
    TYPE: {
      value: 'typ',
      path: 'typ',
    },
    TERM: {
      path: 'typ/:type/termin',
      value: 'termin',
    },
    SPECIALIST: {
      path: 'typ/:type/termin/:from/:to/:slotType/specjalista',
      value: 'specjalista',
    },
    PATIENT_DATA: {
      value: 'dane-pacjenta',
      path: 'dane-pacjenta',
    },
    SUMMARY: {
      path: ':id/podsumowanie/:uuid/:account_id',
      value: 'podsumowanie',
    },
  },
  MAIN: {
    value: '/',
  },
  BLOG: {
    value: 'blog',
  },
  ARTICLE: {
    path: 'blog/artykul/:slug',
    value: 'blog/artykul',
  },
  SPECIALISTS: {
    value: 'specjalisci',
  },
  SPECIALIST: {
    path: 'specjalisci/:id',
    value: 'specjalisci',
  },
  CONTACT: {
    value: 'kontakt',
  },
  ERROR: {
    value: 'blad',
  },
};
